( function( $ ) {
	'use strict';

	$( function() {
        const $shareButtons     = $( '.js-share' );
        const $shareAction      = $( '.js-share-action' );
        const $shareActionClose = $( '.js-share-action-close' );
        const activeClass       = 'is-active';

        $shareButtons.on( 'click', function( e ) {
            e.preventDefault();

            const shareData = {
                title: document.title,
                url: window.location.href,
            };

            try {
                navigator.share( shareData );
            } catch ( err ) {
                if ( !err.toString().includes( 'AbortError' ) ) {
                    $( this ).blur();
                    $shareAction.toggleClass( activeClass );
                }
            }
        } );

        $shareActionClose.on( 'click', function() {
            if ( $shareAction.hasClass( activeClass ) ) {
                $shareAction.removeClass( activeClass );
            }
        } );
    } );
} )( jQuery );
